import { render } from "./KalenderActions.vue?vue&type=template&id=a45c9714"
import script from "./KalenderActions.vue?vue&type=script&lang=js"
export * from "./KalenderActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__